import {type NestedArrayKeys, type NestedObjectKeys, type NestedStringKeys} from './utils.ts'
import type * as strings from './locales/en/strings.json'
// eslint-disable-next-line no-restricted-imports
import {type TOptions} from 'i18next'

export enum TranslationNamespaces {
    Strings = 'strings',
}

export type TranslationKeys = NestedStringKeys<typeof strings, undefined, TranslationNamespaces.Strings>
export type TranslationArrayKeys = NestedArrayKeys<typeof strings, undefined, TranslationNamespaces.Strings>
export type TranslationObjectKeys = NestedObjectKeys<typeof strings, undefined, TranslationNamespaces.Strings>

type PlayerDisplayNameStart = '\uE000'
type PlayerDisplayNameEnd = '\uE001'
export type PlayerDisplayName = `${PlayerDisplayNameStart}${string}${PlayerDisplayNameEnd}`
export const PLAYER_DISPLAY_NAME_START: PlayerDisplayNameStart = '\uE000'
export const PLAYER_DISPLAY_NAME_END: PlayerDisplayNameEnd = '\uE001'

type PlayerDisplayNameVariable = `playerName${string}`
interface PlayerDisplayNameOption {
    [key: PlayerDisplayNameVariable]: PlayerDisplayName
}

export type TranslationOptions = TOptions & PlayerDisplayNameOption

export interface TranslationObject {
    key: TranslationKeys
    options?: TranslationOptions | undefined
}

export interface NestedTranslation {
    [key: string]: TranslationObject | TranslationObject[]
}

export type RelativeTimeFormatUnit =
    | 'year'
    | 'years'
    | 'quarter'
    | 'quarters'
    | 'month'
    | 'months'
    | 'week'
    | 'weeks'
    | 'day'
    | 'days'
    | 'hour'
    | 'hours'
    | 'minute'
    | 'minutes'
    | 'second'
    | 'seconds'
